import APIService from '@/services/APIService';

export default {
  getMeetingRoom(id) {
    return APIService.get(`/meeting/${id}/room`);
  },
  getMeeting(id) {
    return APIService.get(`/meeting/${id}`);
  },

};
